module.exports = __webpack_public_path__ + "lia-small-ead0ea1f8a6edca98ec40cbf3fcf3f99.webp";